import React from 'react';
import NumberFormat from 'react-number-format';

type Props = {
  amountInCents: number,
  decimalScale?: number,
}

const CurrencyDisplay = ({ amountInCents, decimalScale = 2 }: Props): JSX.Element => (
  <NumberFormat
    value={(amountInCents / 100)}
    displayType="text"
    decimalScale={decimalScale}
    fixedDecimalScale
    thousandSeparator
    prefix="$"
  />
);

export default CurrencyDisplay;
